import { render, staticRenderFns } from "./GImageUser.vue?vue&type=template&id=7164f628"
import script from "./GImageUser.vue?vue&type=script&lang=js"
export * from "./GImageUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports